import React from "react"
import {makeStyles} from "@mui/styles"

import InputCardNumber from "./InputCardNumber"
import ConfirmCardNumber from "./ConfirmCardNumber"
import InputFlawNumber from "./InputFlawNumber"
import ActionHeader from "./ActionHeader"
import InputCardNumberWithRetail from "./InputCardNumberWithRetail"
import InventoryActionPanel from "./InventoryActionPanel"
import { Box } from "@mui/material"

const baseAction = {
	textAlign: "center",
	alignSelf: "center",
	width: "100%",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
}

const useStyles = makeStyles(() => ({
	root: {
		...baseAction,
		"& form": {
			...baseAction
		}
	},
		noSelection: {
				maxWidth: 438,
				fontWeight: 300,
				fontSize: 37,
				lineHeight: "43px",
				marginTop: 120
		}
}))

const ActionContent = (props) => {
		const { 
			step,
			selectedCard,
			openModal,
			textHeader,
			handleClose,
			handleValidate,
			onSubmitWithRetail,
			valuesByStep,
			onChangeInputWithRetail,
			isTablet,
			setValue,
			lostActionInfos,
			isInventory,
			noDisplay,
			hub,
			fridgeFilter,
			onConfirmInventory,
			onTransfer,
			preordersVolume = 0
		} = props
	const classes = useStyles()

		return (
				<>
						{/* header */}
						{ selectedCard.length !== 0 &&
								<ActionHeader text={textHeader} handleClose={handleClose}/>
						}

						<div className={classes.root}>
								{/* none selected display */}
								{ step === 0 && selectedCard.length === 0  &&
										<div className={classes.noSelection}>
											{!isInventory &&
												<>
													Choisissez un produit à réceptionner
												</>
											}
											{isInventory &&
												<>
													Choisissez un produit
												</>
											}
										</div>
								}
		
								{/*
								  * KFC-353: on a retail hub the inventory gets its own panel — two tabs, one
								  * brick per fridge in view, and a transfer form. Everything else, reception
								  * included, keeps the flow below untouched.
								  */}
								{!noDisplay && selectedCard.length !== 0 && isInventory && hub?.activeRetailOffer && (
									<InventoryActionPanel
										selectedCard={selectedCard}
										fridgeFilter={fridgeFilter}
										onConfirmInventory={onConfirmInventory}
										onTransfer={onTransfer}
									/>
								)}

								{!noDisplay && selectedCard.length !== 0 && !(isInventory && hub?.activeRetailOffer) && (
									<Box sx={hub?.activeRetailOffer ? { paddingTop: "32px" } : {}}>
										{/* one selected display */}
										{step === 1
											? hub?.activeRetailOffer
												? (
													<InputCardNumberWithRetail
														selectedCard={selectedCard} 
														onSubmit={onSubmitWithRetail}
														isTablet={isTablet}
														initialValues={valuesByStep[1]}
														onChangeInput={onChangeInputWithRetail}
														preordersVolume={preordersVolume}
													/>
												)
												: <InputCardNumber 
													selectedCard={selectedCard} 
													openModal={openModal}
													handleValidate={handleValidate}
													isTablet={isTablet}
													setValue={setValue}
													isInventory={isInventory}
												/>
											: null
										}

										{/* Confirm input */}
										{step === 2
												? hub?.activeRetailOffer
													? (
														<InputCardNumberWithRetail
															selectedCard={selectedCard} 
															onSubmit={onSubmitWithRetail}
															isTablet={isTablet}
															initialValues={valuesByStep[2]}
															onChangeInput={onChangeInputWithRetail}
															preordersVolume={preordersVolume}
															isConfirmation
														/>
													)
													: <ConfirmCardNumber 
														selectedCard={selectedCard} 
														openModal={openModal} 
														handleValidate={handleValidate} 
														isTablet={isTablet} 
														setValue={setValue}
														isInventory={isInventory}
													/>
												: null
										}

										{/* set flaw or break meal */}
										{ step === 3 &&
												<InputFlawNumber
													openModal={openModal}
													handleValidate={handleValidate} 
													isTablet={isTablet}
													setValue={setValue}
													lostActionInfos={lostActionInfos}
												/>
										}
									</Box>
								)}

						</div>
				</>
		)
}

export default ActionContent